import Badge from '@/ui/components/Badge/Badge';

export default Badge;
